export default __webpack_public_path__ + "videos/1e638264e1086cdca4a8432f3cb0a500.mp4";